import { fillVariants } from "../../../styles/utils/fill"
import { classNames } from "../../../utils"
import type { IconProps } from "../../types"

export function Apple({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Apple"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      viewBox="0 0 20 20"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_2196_47199)">
        <path d="M17.6219 6.818C17.5059 6.908 15.4579 8.062 15.4579 10.628C15.4579 13.596 18.0639 14.646 18.1419 14.672C18.1299 14.736 17.7279 16.11 16.7679 17.51C15.9119 18.742 15.0179 19.972 13.6579 19.972C12.2979 19.972 11.9479 19.182 10.3779 19.182C8.84786 19.182 8.30386 19.998 7.05986 19.998C5.81586 19.998 4.94786 18.858 3.94986 17.458C2.79386 15.814 1.85986 13.26 1.85986 10.836C1.85986 6.948 4.38786 4.886 6.87586 4.886C8.19786 4.886 9.29986 5.754 10.1299 5.754C10.9199 5.754 12.1519 4.834 13.6559 4.834C14.2259 4.834 16.2739 4.886 17.6219 6.818ZM12.9419 3.188C13.5639 2.45 14.0039 1.426 14.0039 0.402C14.0039 0.26 13.9919 0.116 13.9659 0C12.9539 0.038 11.7499 0.674 11.0239 1.516C10.4539 2.164 9.92186 3.188 9.92186 4.226C9.92186 4.382 9.94786 4.538 9.95986 4.588C10.0239 4.6 10.1279 4.614 10.2319 4.614C11.1399 4.614 12.2819 4.006 12.9419 3.188Z" />
      </g>
      <defs>
        <clipPath id="clip0_2196_47199">
          <rect height="20" width="20" />
        </clipPath>
      </defs>
    </svg>
  )
}
